import { List, Popup } from "devextreme-react";
import { ToolbarItem } from "devextreme-react/cjs/popup";
import { useCallback, useEffect, useRef, useState } from "react";
import useAxiosPrivate, { axiosHrPrivate } from "../../../../../api/useAxios";

function CheckListTemplateDocumentinfoSelect({
    visible, setVisible, onHiding, employeeDocumentInfos,
    setEmployeeDocumentInfos, updateFormData }) {

    //employeeDocumentInfos  dışardan alacam
    //api / EmployeeDocumentInfo dan veri gelince dışardan gelenleri otomatik işaretleyeceğim
    //    tamam butonu ile seçilenleri setEmployeeDocumentInfos ile dışarı gönderecem

    const refList = useRef(null)
    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)
    const [dataLoading, setDataLoading] = useState(false)
    const [formData, setFormData] = useState([])
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);


    const hideInfo = useCallback(() => {
        setVisible(false);

    }, [setVisible]);

    const okInfo = useCallback(() => {
        if (!selectedItemKeys)
            setEmployeeDocumentInfos(null)

        let data = formData.filter(item => selectedItemKeys.includes(item.id))
        setEmployeeDocumentInfos(data)
        if (updateFormData)
            updateFormData(data)
        setVisible(false)
    }, [formData, setFormData, selectedItemKeys, setVisible])

    const getCloseButtonOptions = useCallback(() => ({
        text: 'İptal',
        stylingMode: 'outlined',
        type: 'normal',
        onClick: hideInfo,
    }), [hideInfo]);

    const getOkButtonOptions = useCallback(() => ({
        text: 'Tamam',
        stylingMode: 'outlined',
        type: 'normal',
        onClick: okInfo,
    }), [okInfo]);

    const loadData = () => {
        (async function () {
            if (setDataLoading) {
                setDataLoading(true)
            }

            await axiosPrivate.get("api/EmployeeDocumentInfo")
                .then((response) => {
                    console.log("response",response)
                    if (response?.status === 200) {
                        if (response.data?.data) {
                            setFormData(response.data?.data)
                        }
                    }
                    if (setDataLoading) {
                        setDataLoading(false)
                    }

                })
                .catch(
                    (err) => {
                        console.log(err)
                        if (setDataLoading) {
                            setDataLoading(false)
                        }
                    }
                )

        })()
    }

    const onSelectedItemKeysChange = useCallback(({ name, value }) => {
        if (name === 'selectedItemKeys') {
            setSelectedItemKeys(value);
        }
    }, [selectedItemKeys, setSelectedItemKeys]);

    useEffect(() => {
        loadData()
    }, [])

    useEffect(() => {
        let keys = employeeDocumentInfos.map((item) => { return item.id })
        //console.log(keys)
        setSelectedItemKeys(keys)

    }, [employeeDocumentInfos])

    return (
        <Popup
            visible={visible}
            onHiding={onHiding}
            title="Döküman Seçimi"
            showTitle={true}
            width={600}
        >

            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={getOkButtonOptions()}
            />
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={getCloseButtonOptions()}
            />
            <List
                ref={refList}
                selectedItemKeys={selectedItemKeys}
                dataSource={formData}
                displayExpr="name"
                keyExpr="id"
                selectionMode="all"
                showSelectionControls={true}
                selectByClick={true}
                onOptionChanged={onSelectedItemKeysChange}

            >

            </List>

        </Popup>
    )
}

export { CheckListTemplateDocumentinfoSelect }